import { consumerFilterPayload } from "utils/consumerFilterUtils";
import api from "api/api";
import SortFinalData from "utils/SortFinalData";

// Helper function to find product title from scores
const findProductTitleInScores = (productsSecondaryDataState, product) => {
    for (let data of productsSecondaryDataState) {
        if (data.scores && Array.isArray(data.scores)) {
            const found = data.scores.find(score =>
                score.title?.split(" ").filter(item => item?.trim()).join("_") === product
            );
            if (found) {
                return found.title;
            }
        }
    }
    return null;
};

const GetPreferenceResult = async ({ product = null, coreDataId = null, type = null, consumerFilter = null, pcs = [], selectedStudy = [], productsSecondaryDataState = null, order = [], productCategoryId = null }) => {
    let analysisResult = [];
    try {
        if (type === "consumerFilter" && consumerFilter) {
            let filter = await consumerFilterPayload(consumerFilter, product, coreDataId);
            const _pc = findProductTitleInScores(productsSecondaryDataState, product);
            await api
                .post(process.env.REACT_APP_SERVER_PATH + `/secondary-study-datas/grouped/`, {
                    variable_category: "Product Preference Analysis",
                    core_data_id: coreDataId,
                    product_code: _pc,
                    consumer_filter: { ...filter },
                    product_category: productCategoryId,
                })
                .then(async (res) => {
                    const updatedObjects = res.data;
                    const finalData = await productsSecondaryDataState.map((datum) => {
                        const matchingObject = updatedObjects.find(
                            (obj) => obj.backendVariable === datum.backendVariable && obj.scores[0]?.coreDataId === datum.scores[0]?.coreDataId
                        );
                        if (matchingObject) {
                            const tempData = datum?.scores.map((ele) => {
                                if (ele.title === matchingObject?.scores?.[0]?.title) {
                                    return matchingObject?.scores?.[0];
                                } else {
                                    return ele;
                                }
                            });
                            return { backendVariable: matchingObject.backendVariable, scores: tempData };
                        } else {
                            return datum;
                        }
                    });
                    analysisResult = finalData;
                })
                .catch((error) => {
                    console.error("Error", error);
                });
        } else if (type === "consumerFilterAll" && consumerFilter) {
            if (pcs.length !== 0) {
                const requests = pcs.map(async (datum) => {
                    let filter = await consumerFilterPayload(consumerFilter, datum.product, datum.coreDataId);
                    // const _pc = datum.product
                    //     .split("_")
                    //     .join(" ");
                    const _pc = findProductTitleInScores(productsSecondaryDataState, datum.product);
                    return api.post(process.env.REACT_APP_SERVER_PATH + `/secondary-study-datas/grouped/`, {
                        variable_category: "Product Preference Analysis",
                        core_data_id: datum.coreDataId,
                        product_code: _pc,
                        consumer_filter: { ...filter },
                        product_category: productCategoryId,
                    });
                });
                await api
                    .all(requests)
                    .then(async (res) => {
                        let finalData = [...productsSecondaryDataState];
                        res.forEach((result) => {
                            const updatedObjects = result.data; // Already getting all objects
                            updatedObjects.forEach((obj) => {
                                const tempData = finalData.map((datum) => {
                                    if (datum.backendVariable === obj.backendVariable && obj.scores[0]?.coreDataId === datum.scores[0]?.coreDataId) {
                                        const tempScores = datum?.scores.map((ele) => {
                                            if (ele.title === obj?.scores?.[0]?.title) {
                                                return obj?.scores?.[0];
                                            } else {
                                                return ele;
                                            }
                                        });
                                        return { backendVariable: obj.backendVariable, scores: tempScores };
                                    } else {
                                        return datum;
                                    }
                                });

                                finalData = [...tempData];
                            });
                        });
                        analysisResult = finalData;
                    })
                    .catch((error) => {
                        console.error("Error", error);
                    });
            }
        } else if (selectedStudy.length !== 0 && (type !== "consumerFilterAll" || type !== "consumerFilter")) {
            const requests = selectedStudy.map((datum) =>
                api.post(process.env.REACT_APP_SERVER_PATH + `/secondary-study-datas/grouped/`, {
                    core_data_id: datum.id,
                    variable_category: "Product Preference Analysis",
                    product_category: productCategoryId,
                })
            );

            await api
                .all(requests)
                .then((res) => {
                    const results = res.map((re) => re.data).flat();
                    analysisResult = results;
                })
                .catch((error) => {
                    console.error("Error", error);
                });
        }
    } catch (error) {
        console.error("Error", error);
    }
    analysisResult = SortFinalData(analysisResult, order);
    return analysisResult;
};

export default GetPreferenceResult;
